<template>
    <AppLayout
        ref="appLayout"
        page="/people"
        pageTitle="People"
        :tabs="true"
        :selectedPeople="selectedPeople"
        :nearMe="nearMe"
        :market="market"
        :retentionGroup="retentionGroup"
        :showArchived="showArchived"
        :showAllStudents="showAllStudents"
        :fabLoading="loading"
        :fabIcon="selectedPeople.length ? 'email' : 'add'"
        :marketOptions="marketOptions"
        @fabAction="
            selectedPeople.length ? getUserEmails() : (userCreate = true)
        "
        @pageSearch="search = $event"
    >
        <template #tabs>
            <v-tabs
                v-model="selectedTab"
                background-color="transparent"
                height="42px"
                class="custom-tabs"
            >
                <v-tab
                    v-for="tab in tabList"
                    :key="tab.slug"
                    class="no-link"
                    :href="`/people/${tab.slug}`"
                >
                    <Link
                        class="no-link flex align-center justify-center min-h-full"
                        @click="selectedPeople = []"
                        :href="`/people/${tab.slug}`"
                        preserve-state
                        >{{ tab.title }}</Link
                    ></v-tab
                >
            </v-tabs>
        </template>

        <v-tabs-items :value="selectedTab" touchless>
            <div v-for="tab in tabList" :key="tab.slug">
                <v-tab-item
                    :value="`/people/${tab.slug}`"
                    :transition="false"
                    v-if="selectedTab == `/people/${tab.slug}`"
                >
                    <div class="pa-1 animate__animated animate__fadeIn">
                        <UserList
                            ref="userList"
                            :role="tab.slug"
                            :people="getPeople(tab.slug)"
                            :headers="getHeaders(tab.slug)"
                            :search="search"
                            :groupBy="groupBy"
                            @selectedPeople="selectedPeople = $event"
                        ></UserList></div
                ></v-tab-item>
            </div>
        </v-tabs-items>

        <UserCreate
            v-if="userCreate"
            @reset="userCreate = false"
            @success="userCreate = false"
            :errors="$page.props.errors"
            :mode="{
                Teacher: selectedTab.includes('teachers'),
                Student: selectedTab.includes('students'),
                Staff: selectedTab.includes('staff'),
            }"
        ></UserCreate>
        <ComposeEmail
            v-if="composeEmail"
            :emails="selectedEmails"
            signature
            sendAsStudio
            tinyMCE
            :user="$page.props.auth.user"
            :errors="errors"
            @success="emailSuccess()"
            @reset="closeModal(() => (composeEmail = false))"
        />
    </AppLayout>
</template>

<script>
import AppLayout from "./../Layouts/AppLayout";
import UserCreate from "./../Components/Users/UserCreate";
import { Link } from "@inertiajs/vue2";
import UserList from "./../Components/Users/UserList.vue";
import ComposeEmail from "./../Components/Users/ComposeEmail.vue";

export default {
    components: {
        AppLayout,
        UserCreate,
        Link,
        UserList,
        ComposeEmail,
    },
    props: {
        teachers: {
            type: Array,
            default: null,
        },
        staff: {
            type: Array,
            default: null,
        },
        propsects: {
            type: Array,
            default: null,
        },
        students: {
            type: Array,
            default: null,
        },
        tabList: {
            type: Array,
            default: null,
        },
        nearMe: {
            type: Boolean,
            default: true,
        },
        market: {
            type: Number,
            default: null,
        },
        marketOptions: {
            type: Array,
            default: () => [],
        },
        retentionGroup: {
            type: String,
            default: null,
        },
        showArchived: {
            type: Boolean,
            default: false,
        },
        showAllStudents: {
            type: Boolean,
            default: false,
        },
        groupBy: {
            type: String,
            default: null,
        },
        errors: {},
    },
    data: function () {
        return {
            userCreate: false,
            search: null,
            loading: false,
            selectedTab: window.location.pathname,
            selectedPeople: [],
            selectedEmails: [],
            composeEmail: false,
            headers: [
                {
                    text: "User Info",
                    align: "start",
                    value: "name",
                },
                {
                    role: ["students", "prospects"],
                    text: "Passes and Memberships",
                    align: "start",
                    value: "purchaseOptions",
                },
                {
                    role: ["students", "prospects"],
                    text: "Membership Prices",
                    align: "start",
                    value: "membershipPrices",
                    sortable: false,
                    permission: "Manage memberships",
                },
                {
                    role: ["students", "prospects"],
                    text: "Tags",
                    align: "start",
                    value: "tags",
                },
                {
                    role: ["students", "prospects"],
                    text: "tagSearch",
                    align: "start",
                    value: "tagSearch",
                    class: "hide",
                    cellClass: "hide",
                },
                {
                    role: ["teachers"],
                    text: "Locations",
                    value: "locations",
                    class: this.nearMe ? "hide" : null,
                    cellClass: this.nearMe ? "hide" : null,
                },
                {
                    role: ["teachers"],
                    text: "Instruments",
                    value: "instruments",
                },
                {
                    role: ["teachers"],
                    text: "Certification Level",
                    value: "certification_level",
                },
                {
                    role: ["staff"],
                    text: "Staff Role",
                    value: "staffRole",
                },
                {
                    text: "Start Date",
                    value: "created_at",
                },
                {
                    role: ["teachers"],
                    text: "Capacity",
                    value: "capacity",
                },
                {
                    role: ["teachers"],
                    text: "Retention",
                    value: "retention",
                    sort: (a, b) => a.value - b.value,
                },
                {
                    role: ["teachers"],
                    text: "Teaching Hours",
                    value: "hours",
                },
                /*{
                    role: "students",
                    text: "Reschedule Eq.",
                    sortable: true,
                    align: "start",
                    value: "reschedules",
                },*/
                /*{
                    role: "students",
                    text: "Retention Group",
                    sortable: true,
                    align: "start",
                    value: "retentionCohort",
                    class: "hide",
                    cellClass: "hide",
                },*/
            ],
        };
    },
    methods: {
        getPeople(tab) {
            return this.$page.props[tab];
        },
        getHeaders(tab) {
            return this.headers.filter(
                (e) =>
                    (!e.role || e.role.includes(tab)) &&
                    (!e.permission || this.can(e.permission))
            );
        },
        getUserEmails() {
            if (!this.selectedPeople.length) return;
            this.loading = true;
            axios
                .get("/api/users/email", {
                    params: {
                        selectedPeople: this.selectedPeople.map((e) => e.id),
                        getStudents: Number(
                            this.selectedTab.includes("students")
                        ),
                    },
                })
                .then((resp) => {
                    this.selectedEmails = resp.data;
                    this.composeEmail = true;
                    this.loading = false;
                });
        },
        emailSuccess() {
            //this.$refs.appLayout.showMessage = true;
            this.closeModal(() => (this.composeEmail = false));
            this.selectedEmails = [];
            this.$refs.userList.selectedPeople = [];
        },
    },
};
</script>
